import { FC } from 'react';
import { Skeleton } from '@material-ui/lab';

interface OverviewItem {
    label: string;
    color: string;
    count: number;
    value: string | number;
    isLoading: boolean;
    onClick: () => void;
}

const ItemDetails: FC<OverviewItem> = ({ label, color, count, isLoading, onClick }) => {
    return (
        <div className="h-8 flex items-center gap-2">
            <div className={`w-[2px] h-full rounded-[5px] bg-${color}`} />
            <div className="flex flex-col gap-1">
                <div className="text-12 font-sf hover:text-sf-primary hover:cursor-pointer" onClick={() => onClick()}>
                    {label}
                </div>
                {isLoading ? (
                    <Skeleton variant="rect" width={10} height={10} />
                ) : (
                    <div className="text-13 font-sf font-bold">{count}</div>
                )}
            </div>
        </div>
    );
};

interface Props<T extends Omit<OverviewItem, 'isLoading'>> {
    title: string;
    items: T[];
    isLoading: boolean;
    className?: string;
}

const OverviewCard = <T extends Omit<OverviewItem, 'isLoading'>>({ title, items, className, isLoading }: Props<T>) => {
    return (
        <div className={`h-full w-full flex flex-col justify-between rounded-lg border ${className}`}>
            <div className="h-12 border-b flex items-center px-4 py-2 flex-none">
                <div className="text-13 font-medium font-sf">{title}</div>
            </div>
            <div className="flex justify-between items-center flex-wrap flex-1 p-6">
                {items.map((item) => (
                    <ItemDetails {...item} key={item.label} isLoading={isLoading} />
                ))}
            </div>
        </div>
    );
};

export default OverviewCard;
